<div>
    <!-- <mwl-gauge class="gauge-width" [max]="500" [dialStartAngle]="-90" [dialEndAngle]="-90.001"
        [value]="gaugeData.data[0]" [animated]="true" [animationDuration]="1" [label]="getLabel">
    </mwl-gauge> -->
</div>